import { Component, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'mwp-dialog-password',
    templateUrl: './password.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogPasswordComponent {

    constructor(
        private dialogRef: MatDialogRef<DialogPasswordComponent>,
    ) {
    }

    close(): void {
        this.dialogRef.close();
    }
}